import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    title: 'Identifica los Ladrones',
    desc: 'Localiza los picos de glucosa y cortisol que están vaciando tu batería.'
  }, {
    title: 'Aplica el Protocolo',
    desc: 'Implementa los micro-estímulos de luz y activación térmica cada mañana.'
  }, {
    title: 'Mantén el Vigor',
    desc: 'Sigue el orden nutricional de sostenimiento para una energía lineal durante 16 horas.'
  }];
  return <section className="py-24 bg-[#132118] border-y border-white/5" data-id="element-67">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-70">
            Cómo funciona en{' '}
            <span className="text-emerald-400" data-id="element-71">3 pasos simples</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 relative" data-id="element-72">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-gradient-to-r from-emerald-500/0 via-emerald-500/30 to-emerald-500/0" data-id="element-73" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative bg-[#162019] p-8 rounded-2xl border border-white/5 pt-14" data-id="element-74">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 rounded-full bg-[#0f1a14] border-2 border-emerald-500 flex items-center justify-center text-2xl font-bold text-emerald-400 shadow-[0_0_15px_rgba(16,185,129,0.3)]" data-id="element-75">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-white mb-4 text-center" data-id="element-76">
                {step.title}
              </h3>
              <p className="text-gray-400 text-center leading-relaxed" data-id="element-77">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}